import { render, staticRenderFns } from "./Overall.vue?vue&type=template&id=1ab6ed7a&scoped=true"
import script from "./Overall.vue?vue&type=script&lang=js"
export * from "./Overall.vue?vue&type=script&lang=js"
import style0 from "./Overall.vue?vue&type=style&index=0&id=1ab6ed7a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e55c6b833ee07bd5ead5f0ade73438ed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab6ed7a",
  null
  
)

export default component.exports